<template>
  <div class="flex justify-center">
    <div class="flex items-center justify-center rounded-full bg-error-100 h-12 w-12 mb-2">
      <CircleX class="h-8 w-8 text-error-400" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CircleX } from 'lucide-vue-next';
</script>
